import React, {useReducer, useEffect } from "react";
import productosXactivoContext from "./productosXactivoContext";
import { getAllProductsXactivo } from "../../api/productsXactivo";
import componenteReducer from "./productosXactivoReducer";

//Types
import { 
    ACTUALIZAR__LIST_ACTIVOXPRODUCTO,
  } from "./productosXactivoActions";


const ProductosXactivoState = props =>{
     
    const initialState = {
        activoXproductoList :null
    };

    const [state, dispatch] = useReducer(componenteReducer, initialState);

    const actualizarActivoXproducto = async () => {
        try{
            const resp = await getAllProductsXactivo();
            const activoXproductoList = resp.data.data;

            dispatch({
                type:  ACTUALIZAR__LIST_ACTIVOXPRODUCTO,
                payload: activoXproductoList
            });
            return activoXproductoList;
        }catch(err){
            console.log(err)
        }
    };

    useEffect(() => {
        actualizarActivoXproducto();
    },[])

    return(
        <productosXactivoContext.Provider
            value={{
                activoXproductoList: state.activoXproductoList,
                actualizarActivoXproducto,
            }}
        >
            {props.children}
        </productosXactivoContext.Provider>
    )

}

export default ProductosXactivoState;